// lib/registrierungPruefen.js — Vereinsregistrierung mit Fehler je Feld (25.10.2026)
//
// Vorher antwortete der Server mit „Validierungsfehler“ und einer Liste in
// `details`, die die Seite nicht las; was fehlte, erfuhr der Verein nie.
// Jetzt: { feld: Meldung }, die Seite zeigt sie am Feld (gleiche Form wie
// PUT /api/vereine/:id, controllers/vereineController.js pruefeVereinsdaten).
//
// Regeln (gemessen an der Tabelle vereine, 25.10.2026):
//   name, email, telefon, benutzername, passwort Pflicht (telefon ist NOT NULL)
//   hausnummer, strasse, plz, ort, ansprechpartner, homepage freiwillig
//   PLZ 4 oder 5 Ziffern (AT/CH 4, DE 5); die Tabelle hat kein Land-Feld
//   Längen wie die Spalten (telefon 20, hausnummer 10, sonst 255)
//
// ⚠️ Abschrift von backend/utils/registrierungPruefen.js — der Test
// utils/__tests__/registrierungPruefen.test.js vergleicht beide.

const RESERVIERT = ['admin'];

function pruefeRegistrierung(d, passwortFehler) {
  const f = {};
  const t = (x) => (typeof x === 'string' ? x.trim() : x == null ? '' : String(x).trim());
  const name = t(d.name);
  if (!name) f.name = 'Bitte den Namen des Vereins eintragen';
  else if (name.length < 2) f.name = 'Mindestens 2 Zeichen';
  else if (name.length > 255) f.name = 'Höchstens 255 Zeichen';
  const mail = t(d.email);
  if (!mail) f.email = 'Bitte eine E-Mail-Adresse eintragen';
  else if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(mail) || mail.length > 255) f.email = 'Das ist keine gültige E-Mail-Adresse';
  const tel = t(d.telefon);
  if (!tel) f.telefon = 'Bitte eine Telefonnummer eintragen, für Rückfragen zur Anmeldung';
  else if (tel.length > 20) f.telefon = 'Höchstens 20 Zeichen';
  const plz = t(d.plz);
  if (plz && !/^\d{4,5}$/.test(plz)) f.plz = 'Die PLZ hat 4 Ziffern (Österreich, Schweiz) oder 5 Ziffern (Deutschland)';
  if (t(d.hausnummer).length > 10) f.hausnummer = 'Höchstens 10 Zeichen';
  for (const k of ['ansprechpartner', 'strasse', 'ort']) if (t(d[k]).length > 255) f[k] = 'Höchstens 255 Zeichen';
  const hp = t(d.homepage);
  if (hp && (/\s/.test(hp) || hp.length > 255)) f.homepage = 'Die Adresse darf keine Leerzeichen enthalten';
  const bn = t(d.benutzername);
  if (!bn) f.benutzername = 'Bitte einen Benutzernamen wählen';
  else if (bn.length < 3) f.benutzername = 'Mindestens 3 Zeichen';
  else if (bn.length > 255) f.benutzername = 'Höchstens 255 Zeichen';
  else if (RESERVIERT.includes(bn.toLowerCase())) f.benutzername = `„${bn}“ ist reserviert, bitte einen anderen Namen wählen`;
  const pw = typeof d.passwort === 'string' ? d.passwort : '';
  if (!pw) f.passwort = 'Bitte ein Passwort wählen';
  else {
    const p = passwortFehler(pw);
    if (p) f.passwort = p;
  }
  return f;
}

export { pruefeRegistrierung };
